export default {"src":"/_next/static/media/checked.af511750.svg","height":9,"width":11,"blurWidth":0,"blurHeight":0};